import { Button, ButtonProps } from '@mui/material'
import { CoreTypography, LeafIcon } from '@thriveglobal/thrive-web-leafkit'
import { defineMessages, useIntl } from 'react-intl'

const messages = defineMessages({
    addToLinkedIn: {
        defaultMessage: 'Add certificate to LinkedIn',
        description: "message to add a certificate to the 'LinkedIn' website"
    }
})

interface Props extends ButtonProps {
    title?: string
    onClick?: () => void
}

const CertificateButton: React.FC<Props> = ({ title, onClick, ...props }) => {
    const intl = useIntl()

    const buttonText = title || intl.formatMessage(messages.addToLinkedIn)

    return (
        <Button
            {...props}
            variant="contained"
            endIcon={
                <LeafIcon
                    icon={'arrow-up-right-from-square'}
                    fontSize={'small'}
                />
            }
            aria-label={buttonText}
            onClick={onClick}
        >
            <CoreTypography customVariant={'buttonNormal'}>
                {buttonText}
            </CoreTypography>
        </Button>
    )
}

export default CertificateButton
